if (typeof init_CollectionContentBlocks != "undefined" && init_CollectionContentBlocks) {

  let enableContentBlock = window.location.href.indexOf("?page=") !== -1 && window.location.href.indexOf("?page=1") == -1 ? false : true;

  //Shopify's no image file, when image picker is empty
  const noUrl = "no-image-50-3d8cc48bd078edcd544c8d60f929ed2d8800a3fc52e0f602e84b1767e392bfcd_2x.gif";

  // Add contentBlocks into collection
  let addContentBlock = function() {
    if (document.querySelectorAll(".coll_content_blocks").length > 0) {
      return;
    } else {
      const contentBlockData = {
        //Content block Object
        block1: {
          image: document.getElementById("content_block_data_1").dataset.contentBlockImgUrl,
          imageMobile: document.getElementById("content_block_data_1").dataset.contentBlockImgMobileUrl,
          link: document.getElementById("content_block_data_1").dataset.contentBlockLink,
        },
        block2: {
          image: document.getElementById("content_block_data_2").dataset.contentBlockImgUrl,
          imageMobile: document.getElementById("content_block_data_2").dataset.contentBlockImgMobileUrl,
          link: document.getElementById("content_block_data_2").dataset.contentBlockLink,
        },
      };

      let contentBlockImages = []; //Declare array for image urls
      let contentBlockImagesMobile = []; //Declare array for image Mobile urls
      let contentBlockLinks = []; //Declare array for links

      //Seperate value to contentBlockImages and contentBlockLinks
      for (let i in contentBlockData) {
        if (contentBlockData[i].image.indexOf(noUrl) == -1 && contentBlockData[i].image != "") {
          //If image isn't empty push image into new array
          contentBlockImages.push(contentBlockData[i].image); //Push images into contentBlockImages
          contentBlockImagesMobile.push(contentBlockData[i].imageMobile); //Push images into contentBlockImages
          contentBlockLinks.push(contentBlockData[i].link); //Push links into contentBlockLinks
        }
      }

      //Combine image and link values; order and combine into one array inside a big array
      let contentBlockArray;

      if (contentBlockImages.length > 0) {
        contentBlockArray = contentBlockImages
          .map(function(contentBlockImages, index) {
            return [
              [contentBlockImages, contentBlockImagesMobile[index], contentBlockLinks[index]]
            ];
          })
          .reduce(function(contentBlockImages, data) {
            return contentBlockImages.concat(data);
          });
      }

      let productBlocksAllCount = document.querySelectorAll("[data-product-index]").length;
      let productBlocksSelected = [];

      //loop every product blocks and add content blocks
      if (productBlocksAllCount > 3) {
        //Change value of i to re-position the content block starting position
        for (let i = 1; i < productBlocksAllCount + 2; i++) {
          let thisProductBlock = document.querySelector(`div [data-product-index="${i}"]`);

          if (i === 3) {
            //actual position 4 but -1 due to index start count of 0
            productBlocksSelected.push(thisProductBlock);
          }

          if (i > 4 && i === productBlocksAllCount) {
            //last position
            productBlocksSelected.push(thisProductBlock);
            break;
          }
        }
      } else {
        for (let i = 0; i < productBlocksAllCount + 2; i++) {
          let thisProductBlock = document.querySelector(`div [data-product-index="${i}"]`);

          if (i === productBlocksAllCount) {
            productBlocksSelected.push(thisProductBlock);
          }
        }
      }

      // Load contentBlock
      let loadContentBlock = function(index) {
        let contentBlockTemplate =
          '<div id="contentBlock{index}" class="grid__item grid-product {gridWidth} coll_content_blocks" data-aos="{dataAOS}">' +
          '<a data-content-block-links="content_links_{index}" href="">' +
          '<img class="coll_content_blocks_images coll_content_blocks_images--mobile lazyload" data-content-block-image="content_image_mobile_{index}">' +
          '<img class="coll_content_blocks_images--desktop lazyload" data-content-block-image="content_image_{index}"></a>' +
          "</div>";

        let blockGridWidth = document.querySelectorAll("#CollectionSection [data-gridwidth]")[0].dataset.gridwidth;
        let blockDataAOS = document.querySelectorAll("#CollectionSection [data-aos]")[0].dataset.aos;

        contentBlockTemplate = contentBlockTemplate.replace(/{gridWidth}/g, blockGridWidth);
        contentBlockTemplate = contentBlockTemplate.replace(/{dataAOS}/g, blockDataAOS);
        contentBlockTemplate = contentBlockTemplate.replace(/{index}/g, index);

        productBlocksSelected[index].insertAdjacentHTML("afterend", contentBlockTemplate); //Select and add contentBlock before productBlocksSelected;

        let thisContentBlockImage = document.querySelector(`[data-content-block-image="content_image_${index}"]`);
        let thisContentBlockImageMobile = document.querySelector(`[data-content-block-image="content_image_mobile_${index}"]`);
        let thisContentBlockLink = document.querySelector(`[data-content-block-links="content_links_${index}"]`);

        let _contentBlockImageUrl = contentBlockArray[index][0];
        let _contentBlockImageMobileUrl = contentBlockArray[index][1];
        let _contentBlockLink = contentBlockArray[index][2];

        thisContentBlockImage.src = _contentBlockImageUrl; //Add src to the selected content image elements;

        if ( _contentBlockImageMobileUrl === "" || _contentBlockImageMobileUrl.indexOf(noUrl) !== -1 ) {
          thisContentBlockImageMobile.src = _contentBlockImageUrl; //Add src to the selected content image mobile elements;
        } else {
          thisContentBlockImageMobile.src = _contentBlockImageMobileUrl; //Add src to the selected content image mobile elements;
        }

        if (_contentBlockLink === "") {
          //Add link to the selected content image elements;
          thisContentBlockLink.classList.add("no_link");
        } else {
          thisContentBlockLink.href = _contentBlockLink;
        }
      }

      if (contentBlockImages.length < productBlocksSelected.length) {
        contentBlockImages.forEach((contentBlockImages, index) =>
          loadContentBlock(index)
        ); //If contentBlock number is lower than productBlocksSelected
      } else {
        productBlocksSelected.forEach((productBlock, index) =>
          loadContentBlock(index)
        );
      }
    }

    //Adjust contentBlock heights with the product blocks
    let adjustContentBlockHeight = function() {
      let contentBlocks = document.querySelectorAll(".coll_content_blocks");
      let productBlockheight = document.querySelectorAll(".grid-product__content")[0].clientHeight;

      contentBlocks.forEach((elem, index) => (contentBlocks[index].style.height = productBlockheight + "px"));
    }

    adjustContentBlockHeight();
    window.addEventListener("resize", adjustContentBlockHeight);

    document.addEventListener("shopify:section:load", addContentBlock);
  }

  if (enableContentBlock == true) {
    window.addEventListener('DOMContentLoaded', addContentBlock);
  }
}
//PLP CONTENT BLOCK END *************************************************
